module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.custom.title":"Custom Cloud Connections"}}')
  delete Component.options._Ctor
}
